import { useState, useEffect } from 'react'
import { useTeamsSDK } from 'use-teams-sdk'

/**
 * Hook to detect if the app is running inside Microsoft Teams
 */
export function useIsTeams() {
  const [isInTeams, setIsInTeams] = useState(false)
  const teamsSDKPromise = useTeamsSDK()

  useEffect(() => {
    // Skip on server-side
    if (typeof window === 'undefined') return

    // First try to detect based on URL patterns and window properties
    const url = window.location.href
    const isTeamsUrl = /teamstab|teamschat|messenger|taskModule/.test(url)
    const isTeamsWindow = window.name && /embedded|iframe/.test(window.name)
    const hasTeamsObject = typeof (window as any).microsoftTeams !== 'undefined'
    const hasTeamsContext =
      document.documentElement.classList.contains('teams-dark') ||
      document.documentElement.classList.contains('teams-light')

    // Set result based on simple detection
    const inTeamsContext = isTeamsUrl || isTeamsWindow || hasTeamsObject || hasTeamsContext
    setIsInTeams(inTeamsContext)

    // If Teams SDK is available, try to get additional context for more accurate detection
    async function checkWithTeamsSDK() {
      try {
        const teamsSDK = await teamsSDKPromise
        if (teamsSDK) {
          // If we can successfully get a context, we're definitely in Teams
          const context = await teamsSDK.app.getContext()
          if (context) {
            setIsInTeams(true)
          }
        }
      } catch (error) {
        // If there's an error, fall back to the simpler detection we did above
        console.error('Failed to detect Teams with SDK:', error)
      }
    }

    checkWithTeamsSDK()
  }, [teamsSDKPromise])

  return isInTeams
}